import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as ComponentConstants from "../../constants/ComponentConstants";
import { formatValidatieStatussesForBeads } from "./NavItemHelper";
import Tooltip from "../common/Tooltip";
import Button from "../common/Button";
import Confirm from "../common/Confirm";
import TabNavIcon from "../common/TabNavIcon";
import Table from "../common/Table";

const Beads = (props) => {

    const { items, confirmStatusPopup, onClickStatusButton, showStatusPopup } = props;

    const tabOrder = getTabOrder();

    let sortedItems = [];
    const statusSummaryText = items.filter(x => x.volledig != 1).length ? "Jouw dossier is nog niet klaar voor ANB" : "Jouw dossier is klaar voor ANB";
    const statusColor = items.filter(x => x.volledig != 1).length ? ComponentConstants.COLOR_RED : ComponentConstants.COLOR_GREEN;
    let svgcontent = {
        [0]: ComponentConstants.ICON_SOCIALEMEDIA,
        [1]: ComponentConstants.ICON_SOCIALEMEDIA,
        [2]: ComponentConstants.ICON_SOCIALEMEDIA
    };
    let iconColors = {
        [0]: ComponentConstants.COLOR_ORANGE,
        [1]: ComponentConstants.COLOR_TURQUOISE_DARK,
        [2]: ComponentConstants.COLOR_PINK
    };
    let statusTitels = {
        [0]: "tab1",
        [1]: "tab2",
        [2]: "tab3"
    };
    if (items) {
        tabOrder.forEach((value) => {
            let filteredItems = items.filter(x => x.tab === value);
            sortedItems = sortedItems.concat(filteredItems);
        });
    }
    let lusStatusses = sortedItems.filter(s => s.tab == 2);
    let statussesVolledig = items && sortedItems.length > 0 ? {
        [0]: sortedItems.find(s => s.tab == 0).volledig,
        [1]: sortedItems.find(s => s.tab == 1).volledig,
        [2]: lusStatusses.filter(s => !s.volledig).length == 0
    } : null;
    let lusStatussesTable = lusStatusses && lusStatusses.length > 0 ? lusStatusses.map((lusStatus, i) => {
        return <Table key={i} type="no-border" style={{ marginBottom: '0px' }}><tr>
            <td style={{ width: '75%' }}>{lusStatus.title}</td><td style={{ width: '25%' }}><span style={{ color: lusStatus.volledig ? ComponentConstants.COLOR_GREEN : ComponentConstants.COLOR_ORANGE }}>{lusStatus.volledig ? "Volledig" : "Nog niet volledig"}</span></td>
        </tr></Table>;
    }) : null;
    let statusTable = items && sortedItems.length > 0 ? sortedItems.map((tabStatus, i) => {
        return <tr key={i}>
            <td style={{ width: '10%' }}>{i <= sortedItems.length - lusStatusses.length ? <TabNavIcon type={svgcontent[i]} color={iconColors[i]} /> : null}</td><td style={{ width: '10%' }}>{i <= sortedItems.length - lusStatusses.length ? statusTitels[i] : ""}</td><td style={{ width: '15%' }}>{i <= sortedItems.length - lusStatusses.length ? <span style={{ color: statussesVolledig[i] ? ComponentConstants.COLOR_GREEN : ComponentConstants.COLOR_ORANGE }}>{statussesVolledig[i] ? "Volledig" : "Nog niet volledig"}</span> : null}</td><td style={{ width: '65%' }}>{tabStatus.tab == 2 ? lusStatussesTable[sortedItems.length - i - 1] : null}</td>
        </tr>;
    }) : null;

    return (items && items.length > 0 ?
        (
            <div className="c-beads-wrapper">
                <div className="c-beads-left">
                    {!showStatusPopup || <Confirm title="Statusdetail van jouw ENTITY" showOnTop hideCancel message=" " children={<Table type="no-border">{statusTable}</Table>} callback={confirmStatusPopup} />}
                    <span style={{ color: statusColor }}>{statusSummaryText}</span>
                    <Tooltip
                        text="In het voorjaar en het najaar worden alle aanvragen voor nado.medicijnen doorgegeven aan het Agentschap voor Natuur en Bos. Indien jouw dossier tijdig is ingediend en de status heeft gekregen ‘dossier klaar voor ANB’ wordt dit automatisch doorgestuurd. Het ANB verwerkt dan al die aanvragen voor machtigingen."
                        tooltipType={ComponentConstants.TOOLTIP_INFO}
                        windowWidth={30}
                        tooltipColor={statusColor}
                        iconColor={statusColor}
                    />
                    <div className="u-clear" style={{ whiteSpace: 'nowrap' }}><Button onClick={onClickStatusButton} text="Toon statusdetail" className="c-button--left" style={{ verticalAlign: 'baseline', textAlign: 'center', width: 'auto', padding: '7px', marginLeft: '5%', marginRight: '5%' }} /></div>
                </div>
            </div>
        ) : null
    );
};

function getTabOrder() {
    return [0, 1, 2, 3, 4, 5];
}

Beads.propTypes = {
    items: PropTypes.array,
    confirmStatusPopup: PropTypes.func.isRequired,
    onClickStatusButton: PropTypes.func.isRequired,
    showStatusPopup: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
    return {
        items: formatValidatieStatussesForBeads(state.validatieStatussen)
    };
}

export default connect(mapStateToProps)(Beads);

